import * as Scrivito from "scrivito";

Scrivito.provideEditingConfig("LoginRedirectPage", {
  title: "Login Redirect",
  hideInSelectionDialogs: true,
  attributes: {
    title: {
      title: "Title",
    },
    intranetStudentLink: {
      title: "Redirect after Login for a Student",
    },
    intranetEmployeeLink: {
      title: "Redirect after Login for a Employee",
    },
  },
  properties: [
    "title",
    "intranetStudentLink",
    "intranetEmployeeLink",
    "loginButtonText",
  ],
});
